export default __webpack_public_path__ + "static/media/this.188c1ca6.svg";